export function formatRatingAverageLabel(average: number) {
  if (average < 2.9) {
    return;
  }

  if (average > 2.9 && average <= 3.9) {
    return 'Bom';
  }

  return 'Excelente';
}

export const getRateLabel = (index: number): string => {
  const labels = ['', 'Péssimo', 'Ruim', 'Razoável', 'Bom', 'Excelente'];
  return labels[index] ?? '';
};
